export function getDomain(url: string): string {
	try {
		const parts = new URL(url.startsWith('http') ? url : `http://${url}`).host.split('.');
		return (parts.length > 2 ? parts.slice(parts.length - 2) : parts).join('.');
	} catch (e) {
		return '';
	}
}
